<template>
  <div class="flex">
    <div class="flex items-center space-x-4 mr-4">
      <div class="bg-text-label w-14 h-14 text-white text-lg font-bold flex items-center justify-center rounded-full"
           :class="{'bg-green':currentStep > 1,'bg-text-label':currentStep === 1}">
        <template v-if="currentStep < 2">1</template>
        <template v-else>
          <font-awesome-icon icon="check" class="text-md"/>
        </template>
      </div>
      <div class="text-bg-contractor text-sm">{{ $t('step1Label') }}</div>
      <div class="w-12 border-b border-dashed border-border-hover"></div>
    </div>
    <div class="flex items-center space-x-4 mr-4">
      <div class="bg-text-ternary w-14 h-14 text-white text-lg font-bold flex items-center justify-center rounded-full"
           :class="{'bg-green':currentStep > 2,'bg-text-label':currentStep === 2}">
        <template v-if="currentStep < 3">2</template>
        <template v-else>
          <font-awesome-icon icon="check" class="text-md"/>
        </template>
      </div>
      <div class="text-bg-contractor text-sm">{{ $t('step2Label') }}</div>
      <div class="w-12 border-b border-dashed border-border-hover"></div>
    </div>
    <div class="flex items-center space-x-4">
      <div class="bg-text-ternary w-14 h-14 text-white text-lg font-bold flex items-center justify-center rounded-full"
           :class="{'bg-text-label':currentStep === 3}">
        3
      </div>
      <div class="text-bg-contractor text-sm">{{ $t('step3Label') }}</div>
    </div>
    <IconUploadPortfolio class="ml-auto -mt-20"/>
  </div>
</template>

<script>
import IconUploadPortfolio from "@/components/icons/IconUploadPortfolio";

export default {
  name: "StepDisplay",
  props: {
    currentStep: {
      type: Number,
      required: true
    }
  },
  components: {IconUploadPortfolio},
  i18n: {
    messages: {
      en: {
        step1Label: 'Upload report',
        step2Label: 'Import data',
        step3Label: 'Done',
      },
      ru: {
        step1Label: 'Загрузка отчета',
        step2Label: 'Импорт данных',
        step3Label: 'Готово',
      }
    }
  }
}
</script>